export default function ({ $axios, redirect, app, req }) {
  // The browser uses the published API port; SSR reaches the backend's Docker
  // service. Sanctum's provider generates absolute URLs, so rewrite those too.
  if (process.server && process.env.BACKEND_INTERNAL_URL) {
    const internal = process.env.BACKEND_INTERNAL_URL
    const browserOrigin = new URL(process.env.BACKEND_URL).origin
    $axios.setBaseURL(internal)
    $axios.onRequest(config => {
      if (config.url && config.url.startsWith(browserOrigin + '/')) {
        config.url = internal + config.url.slice(browserOrigin.length)
      }
      if (!config.headers.referer && req) {
        config.headers.referer = 'http://' + req.headers.host + '/'
      }
    })
  }
  $axios.onError(error => {
    if (error !== undefined && error.response !== undefined && error.response.status === 401) {
      // Auth handles an expired session by clearing the user. Redirecting its
      // initial fetch would also evict guests from public, localized pages.
      const url = error.config && error.config.url
      if (url && new URL(url, 'http://localhost').pathname === '/api/user') return

      redirect(app.localePath('/users'))
    }
  })
}
